// extracted by mini-css-extract-plugin
export default {"containerBig":"styles_containerBig__A0RqC","container":"styles_container__5sd4w","title":"styles_title__dVXAY","text":"styles_text__2iMHq"};